import type { TransitionProps } from 'vue';

const previousInert = new WeakMap<Element, string | null>();

function lock(element: Element)
{
    if (!previousInert.has(element))
        previousInert.set(element, element.getAttribute('inert'));
    element.setAttribute('inert', '');
}

function restore(element: Element)
{
    if (!previousInert.has(element))
        return;
    const value = previousInert.get(element);
    if (value === null)
        element.removeAttribute('inert');
    else
        element.setAttribute('inert', value!);
    previousInert.delete(element);
}

export const pageContentTransition: TransitionProps = {
    mode: 'out-in',
    enterActiveClass: '![transition:opacity_0.12s_ease] motion-reduce:!transition-none',
    enterFromClass: '!opacity-0 motion-reduce:!opacity-100',
    enterToClass: '!opacity-100',
    leaveActiveClass: 'pointer-events-none ![transition:opacity_0.12s_ease] motion-reduce:!transition-none',
    leaveFromClass: '!opacity-100',
    leaveToClass: '!opacity-0',
    onBeforeEnter: restore,
    onBeforeLeave: lock,
    onAfterEnter: restore,
    onAfterLeave: restore,
    onEnterCancelled: restore,
    onLeaveCancelled: restore
};

export function sharesPageContentTransition(to: { meta: Record<string, unknown> }, from: { meta: Record<string, unknown> })
{
    const group = to.meta.contentTransitionGroup;
    return typeof group === 'string' && group.length > 0
        && group === from.meta.contentTransitionGroup
        && !!to.meta.pageTransition && !!from.meta.pageTransition;
}

export function preservesPageView(to: { name?: unknown; meta: Record<string, unknown> }, from: { name?: unknown; meta: Record<string, unknown> })
{
    return !!to.name && to.name === from.name
        && to.meta.preserveViewOnParamChange === true
        && from.meta.preserveViewOnParamChange === true;
}
